module.exports = __webpack_public_path__ + "img/group-394.146e24c.png";